import { render, staticRenderFns } from "./LanguageInfoTalentFind.vue?vue&type=template&id=6e2ef476"
import script from "./LanguageInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./LanguageInfoTalentFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports